import React, { useState } from 'react'
import { Page } from '@shopify/polaris';
import ShippingsList from '../../components/ShippingsList';
import NoShipping from '../../components/NoShipping';
import Loader from '../../components/Loader';
import { setToast } from '../../store/actions/configActions';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import constants from '../../store/constants';
import ImportCSV from "../../components/ImportCSV";
import { setOpenWidget } from '../../store/actions/shippingActions';
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';

const Shippings = () => {

    const { features, store } = useSelector(state => state.ConfigReducer)
    const { shippingList, shippingCounts, shippingFetching } = useSelector(state => state.ShippingReducer)
    const dispatch = useDispatch()
    const fetchJson = useAuthenticatedFetch()
    const [rates] = useState(features.indexOf(constants.RATES) >= 0)
    const [csv] = useState(features.indexOf(constants.CSV) >= 0)
    const [exporting, setExporting] = useState(false)
    // const [openWidget, setOpenWidget] = useState(false)

    const fetchingLoader = {
        width: "80px",
        height: "80px",
        margin: "20px auto",
        borderWidth: "10px",
        borderStyle: "double solid solid",
        borderColor: "#008060",
    }

    const exportShippingRates = async () => {
        try {
            if (csv) {
                setExporting(true)
                const blob = await fetchJson(`/file/download/csv?shop=${store.shop_name}`, { method: 'GET', parse: 'blob' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "shipping.csv");
                document.body.appendChild(link);
                link.click();
            } else {
                dispatch(setToast({ active: true, error: true, content: 'This feature is not available in current plan.' }))
            }

        } catch (error) {
            console.error(error);
        } finally {
            setExporting(false)
        }
    }

    return <React.Fragment>
        <Page
            title="Shipping Rates"
            {...(shippingCounts > 0 && {
                primaryAction: {
                    content: <Link to={rates ? `/rates/new` : "#"} style={{ textDecoration: 'none', color: 'white' }} onClick={() => {
                        if (!rates) {
                            dispatch(setToast({ active: true, content: "This feature is not available in current plan.", error: true }))
                        }
                    }}>Add Shipping</Link>,
                    disabled: !rates,
                },
                secondaryActions: [
                    {
                        content: "Import",
                        disabled: !csv,
                        onAction: () => {
                            if (csv) {
                                dispatch(setOpenWidget(true))
                            } else {
                                dispatch(setToast({ active: true, error: true, content: 'This feature is not available in current plan.' }))

                            }
                        }
                    },
                    {
                        content: "Export",
                        loading: exporting,
                        disabled: !csv || exporting,
                        onAction: exportShippingRates
                    },
                ]
            })}

        >

            {shippingFetching ? <Loader style={fetchingLoader} /> : (
                shippingCounts > 0 ? <ShippingsList /> : <NoShipping />
            )}
        </Page>
        <ImportCSV />
    </React.Fragment >
}

export default Shippings






